// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { formatISO as fn } from "../formatISO.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const formatISO = convertToFP(fn, 1);

// Fallback for modularized imports:
export default formatISO;
